<template>
	<article 
		v-show="activate === true"
		class="count-down-timer"
		ref="timer"
	>
		<div
			class="time_container"
			v-bind:style="{
				textAlign: 'center',
				backgroundColor: setting.bg_color,
				paddingTop: '3px',
				paddingBottom: '3px',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				fontWeight: 'bold',
				fontSize: setting.font_size,		
			}"
			v-show="time_out === false"
		>
			<section 
				v-if="setting.card_type !== 'endUpCardSetting'"
				class="t_description"
				v-bind:style="{
					marginRight: '0.3em',
					color: setting.description_color,
				}"
			>
				{{ setting.description }}
			</section>

			<section 
				v-else
				class="t_description"
				v-bind:style="{
					marginRight: '0.3em',
					color: setting.timer_off_text_color,
				}"
			>
				{{ setting.timer_off_text }}
			</section>


			<section class="t_days"
				v-show="setting.card_type !== 'endUpCardSetting'"
				v-bind:style="{
					textAlign: 'center',
					minWidth: '24px',
					color: setting.d_value_color,
				}"			
			>
				00
			</section>
			<section
				v-show="setting.card_type !== 'endUpCardSetting'"
				class="t_days_unit"
				v-bind:style="{
					color: setting.d_text_color,
				}"
			>
				{{ setting.d_text }}
			</section>
			<section class="t_hours"
				v-show="setting.card_type !== 'endUpCardSetting'"
				v-bind:style="{
					textAlign: 'center',
					width: '24px',
					color: setting.h_value_color,
				}"	
			>
				00
			</section>
			<section
				v-show="setting.card_type !== 'endUpCardSetting'"
				class="t_hours_unit"
				v-bind:style="{
					marginRight: '0.3em',
					color: setting.h_text_color,
				}"
			>
				{{ setting.h_text }}
			</section>
			<section
				v-show="setting.card_type !== 'endUpCardSetting'"
				class="t_minutes"
				v-bind:style="{
					textAlign: 'center',
					width: '23px',
					color: setting.m_value_color,
				}"					
			>
				00
			</section>
			<section
				v-show="setting.card_type !== 'endUpCardSetting'"
				class="t_minutes_unit"
				v-bind:style="{
					marginRight: '0.3em',
					color: setting.m_text_color,
				}"
			>
				{{setting.m_text}}
			</section>
			<section
				v-show="setting.card_type !== 'endUpCardSetting'"
				class="t_seconds"
				v-bind:style="{
					textAlign: 'center',
					width: '24px',
					color: setting.s_value_color,
				}"					
			>
				00
			</section>
			<section
				v-show="setting.card_type !== 'endUpCardSetting'"
				class="t_seconds_unit"
				v-bind:style="{
					color: setting.s_text_color,
				}"				
			>
				{{setting.s_text}}
			</section>
			<section
				v-show="setting.card_type !== 'endUpCardSetting'"
				class="t_description_end"
				v-bind:style="{
					marginLeft: '0.3em',					
					color: setting.description_end_color,
				}"				
			>
				{{ setting.description_end }}
			</section>
		</div>
		<div
			class="time_off_text"
			v-bind:style="{
				textAlign: 'center',
				backgroundColor: setting.bg_color,
				paddingTop: '3px',
				paddingBottom: '3px',
				display: time_out === true && setting.end_at !== '' && setting.start_at !== '' ? 'flex' : 'none',
				justifyContent: 'center',
				alignItems: 'center',
				fontWeight: 'bold',
				fontSize: setting.font_size
			}"
		>
			<section 
				class="t_off_text"
				v-bind:style="{
					marginRight: '0.3em',
					color: setting.timer_off_text_color,
				}"
			>
				{{ setting.timer_off_text }}
			</section>
		</div>
	</article>
</template>
<script>

	import { mapState, mapGetters } from 'vuex';

	export default {
		name: 'Timer',
		components: {},
		props: {
			setting: Object,
			activate: Boolean,
			loadOldSettingData: Boolean
		},
		data: function() {
			return {
				timer_text: "",
				timer: {},
				time_out: false, // 預設倒數計時時間都尚未結束
				marketing_card_setting: null
			}
		},
		destroyed: function() {
			clearInterval(this.timer);
		},
		created() {
			// console.log(this.setting);
			// console.log(this.activate);
		},
		computed: {
			...mapState(['is_auto_coupon','marketing_card','old_setting_data']),
        	...mapGetters(["oldSettingData"])
		},
		methods: {
			initTimer: function(campaign_end_at, end_at, repeat_day) {
				// console.log(repeat_day);
				console.log('init_timer:',campaign_end_at);
				console.log('init_timer:',end_at);
				console.log('init_timer', repeat_day)

				let that = this
				let now = new Date().getTime()
				let distance = end_at - now;
					console.log("distance", distance);

				let campaign_distance = campaign_end_at - now
					console.log("campaign_distance", campaign_distance);

				clearInterval(that.timer);
				if ((isNaN(distance) && isNaN(campaign_distance) || distance < 0) && repeat_day === 0) {
					
					clearInterval(that.timer);
					that.$refs.timer.getElementsByClassName("t_days")[0].innerText = '00'
					that.$refs.timer.getElementsByClassName("t_hours")[0].innerText = '00'
					that.$refs.timer.getElementsByClassName("t_minutes")[0].innerText = '00'						
					that.$refs.timer.getElementsByClassName("t_seconds")[0].innerText = '00'
					that.time_out = false
					return
				}
				this.timer = setInterval(async function() {

					let now = new Date().getTime()
					// console.log("現在時刻 :",now);
					let distance = end_at - now;
					// console.log(distance);
					// console.log("distance",isNaN(distance));
					// let campaign_distance = campaign_end_at - now
					// console.log(campaign_distance);
					// console.log("campaign_distance",isNaN(campaign_distance));
					

					if (distance <= 0) {
						if (repeat_day !== 0 && repeat_day !== '' && !isNaN(repeat_day)) {
							let repeat_day_second = repeat_day *  24 * 60 * 60 * 1000
							// console.log('重複時間',repeat_day_second)
							let lost_duration = 0
							if (new Date().getTime() - end_at < repeat_day_second) {
								console.log('進1')
								lost_duration = repeat_day_second - (new Date().getTime() - end_at)  
							}
							else {
								console.log('進2')
								lost_duration = repeat_day_second - (new Date().getTime() - end_at )% repeat_day_second
							}

							distance = lost_duration
						}
					}


					console.log('d_distance:',distance)

					if (distance <= 0){
						console.log("過期");
						clearInterval(that.timer);
						that.$refs.timer.getElementsByClassName("t_days")[0].innerText = '00'
						that.$refs.timer.getElementsByClassName("t_hours")[0].innerText = '00'
						that.$refs.timer.getElementsByClassName("t_minutes")[0].innerText = '00'						
						that.$refs.timer.getElementsByClassName("t_seconds")[0].innerText = '00'
						that.time_out = false		
						return
					}
					else {
						console.log("沒過期");
						let show_units = that.getCountDownUnit(distance)
						let units = Object.keys(show_units)
						units.forEach(function(unit){
							that.$refs.timer.getElementsByClassName(unit)[0].innerText = show_units[unit]
						})
					}

					// if (campaign_distance < end_at && campaign_distance < 0 && campaign_end_at !== "") {
					// 	console.log("2");
					// 	that.time_out = true
					// 	return
					// }

					// that.time_out = false

					// if (that.oldSettingData !== null) {
						
					// 	if ( campaign_distance < end_at && campaign_distance < 0 && now < end_at && campaign_end_at !== 0) {
					// 		console.log(campaign_end_at);
					// 		console.log("2");
					// 		that.time_out = true
					// 		return
					// 	}

					// 	if ( distance < 0 ) {
					// 		clearInterval(that.timer);
					// 		that.$refs.timer.getElementsByClassName("t_days")[0].innerText = '00'
					// 		that.$refs.timer.getElementsByClassName("t_hours")[0].innerText = '00'
					// 		that.$refs.timer.getElementsByClassName("t_minutes")[0].innerText = '00'						
					// 		that.$refs.timer.getElementsByClassName("t_seconds")[0].innerText = '00'
					// 		that.time_out = false
					// 		return
					// 	}						

					// 	console.log("1");
					// 	if ( (that.oldSettingData.campaign_end_at === "" || that.oldSettingData.campaign_end_at === null) || campaign_distance < 0) {
					// 		console.log("2");
					// 		// console.log(typeof(that.setting.campaign_end_at));
					// 		// console.log(that.setting.campaign_end_at);
					// 		// console.log("1");
					// 		console.log(distance);
					// 		let show_units = that.getCountDownUnit(distance)
					// 		let units = Object.keys(show_units)
					// 		units.forEach(function(unit){
					// 			that.$refs.timer.getElementsByClassName(unit)[0].innerText = show_units[unit]
					// 		})

					// 	} else {
					// 		console.log("3");
					// 		//console.log(typeof(that.setting.campaign_end_at));
					// 		//console.log(that.setting.campaign_end_at);
					// 		// console.log("2");
					// 		// console.log(campaign_distance);
					// 		let show_units = that.getCountDownUnit(campaign_distance)
					// 		let units = Object.keys(show_units)
					// 		units.forEach(function(unit){
					// 			that.$refs.timer.getElementsByClassName(unit)[0].innerText = show_units[unit]
					// 		})
					// 		// console.log('剩餘時間：',show_units)
					// 	}	
					// }else {
					// 	// console.log("4"); 
					// 	if (that.setting.end_at === "" && that.setting.campaign_end_at === "") {
					// 		clearInterval(that.timer);
					// 		that.$refs.timer.getElementsByClassName("t_days")[0].innerText = '00'
					// 		that.$refs.timer.getElementsByClassName("t_hours")[0].innerText = '00'
					// 		that.$refs.timer.getElementsByClassName("t_minutes")[0].innerText = '00'						
					// 		that.$refs.timer.getElementsByClassName("t_seconds")[0].innerText = '00'
					// 		that.time_out = false		
					// 		return
					// 	} 
					// 	if (that.setting.campaign_end_at === "") {
					// 		console.log("5");
					// 		//console.log(typeof(that.setting.campaign_end_at));
					// 		//console.log(that.setting.campaign_end_at);
					// 		// console.log("1");
					// 		let show_units = that.getCountDownUnit(distance)
					// 		let units = Object.keys(show_units)
					// 		units.forEach(function(unit){
					// 			that.$refs.timer.getElementsByClassName(unit)[0].innerText = show_units[unit]
					// 		})

					// 	} else {
					// 		// console.log("6");
					// 		//console.log(typeof(that.setting.campaign_end_at));
					// 		//console.log(that.setting.campaign_end_at);
					// 		// console.log("2");
					// 		// console.log(campaign_distance);
					// 		let show_units = that.getCountDownUnit(campaign_distance)
					// 		let units = Object.keys(show_units)
					// 		units.forEach(function(unit){
					// 			that.$refs.timer.getElementsByClassName(unit)[0].innerText = show_units[unit]
					// 		})
					// 		// console.log('剩餘時間：',show_units)
					// 	}	
					// }
					

					// if (show_units.t_days <= 0 && show_units.t_hours <= 0 && show_units.t_minutes <= 0 && show_units.t_seconds <= 0) {

					// }
					

				}, 1000);
			},
			getCountDownUnit: function(distance) {
				// console.log(distance);
				var days = Math.floor(distance / (1000 * 60 * 60 * 24));
				var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				var seconds = Math.floor((distance % (1000 * 60)) / 1000);
				days = days.toString()
				if (days.length === 1) {
					days = '0' + days
				}
				hours = hours.toString()
				if (hours.length === 1) {
					hours = '0' + hours
				}				
				minutes = minutes.toString()
				if (minutes.length === 1) {
					minutes = '0' + minutes
				}	
				seconds = seconds.toString()
				if (seconds.length === 1) {
					seconds = '0' + seconds
				}	
				
				let result = {
					t_days: days,
					t_hours: hours,
					t_minutes: minutes,
					t_seconds: seconds
				}
				// console.log(result);
				return result
			}
		},
		watch: {
			setting: function(timer_setting) {
				console.log("setting");
				console.log(this.activate);
				console.log(timer_setting);
				// timer_setting
				let end_at = new Date(timer_setting.end_at).getTime()
				let campaign_end_at = new Date(timer_setting.campaign_end_at).getTime()
				if (isNaN(end_at)) {
					end_at = 0
				}
				
				if (this.activate) {
					console.log("this.activate",this.activate);
					console.log("!!!!!!!",timer_setting);
					console.log("!!!!!!!!",this.oldSettingData);
					this.oldSettingData !== null
							? this.initTimer(new Date(this.oldSettingData.campaign_end_at).getTime(), new Date(this.oldSettingData.end_at).getTime(), this.oldSettingData.repeat_day)
							: this.initTimer(campaign_end_at, end_at, Number(timer_setting.repeat_day))
					// this.initTimer(campaign_end_at, end_at, Number(timer_setting.repeat_day))
				}
			},
			activate: {
				handler: function(is_activate) {
					console.log("activate");
					console.log(is_activate);
					if (!is_activate){
						clearInterval(this.timer);
					}
					else {
						console.log('JJJ 294',this.setting)
						console.log('AAA 387', this.oldSettingData);
						// console.log(this.setting.campaign_end_at);
						// console.log(this.setting.end_at);
						// console.log(this.setting.repeat_day);
						
						if (this.oldSettingData !== null) {
							console.log('this.oldSettingData.campaign_end_at', this.oldSettingData.campaign_end_at);
							console.log('this.oldSettingData.end_at', this.oldSettingData.end_at);
							console.log('this.oldSettingData.repeat_day', this.oldSettingData.repeat_day);
							this.initTimer(new Date(this.oldSettingData.campaign_end_at).getTime(), new Date(this.oldSettingData.end_at).getTime(), Number(this.oldSettingData.repeat_day))
						} else {
							console.log('this.setting.campaign_end_at', this.setting.campaign_end_at);
							console.log('this.setting.end_at', this.setting.end_at);
							console.log('this.setting.repeat_day', this.setting.repeat_day);
							this.initTimer(new Date(this.setting.campaign_end_at).getTime(), new Date(this.setting.end_at).getTime(), Number(this.setting.repeat_day))
						}
					}
				},
				deep: true
			},
			marketing_card: {
				handler: function(newValue) {
					// if (newValue) {
						console.log('Timer 378行',newValue);
						let that = this 
						that.marketing_card_setting = newValue
					// }
				},
				deep: true,
				immediate: true
        	},
			load_old_setting_data: {
				handler: function(newValue) {
					if (newValue) {
						this.load_old_setting_data = newValue 
					}
				}
				// immediate: true
        	},
			old_setting_data: {
				handler: function(newValue) {
					if (newValue) {
						this.load_old_setting_data = newValue 
					}
				},
				immediate: true,
				deep: true
			}
		},
		mounted() {
			console.log("yo Timer1", this.setting);
		}
	}
</script>
<style scoped>
	
</style>